let isOpen: boolean = false;

export const PDF_VIEWER_CHANGED_EVENT = 'pdfViewer:changed';

export function getPdfViewerOpen() {
  return isOpen;
}

export function setPdfViewerOpen(next: boolean) {
  isOpen = next;
  document.dispatchEvent(new CustomEvent(PDF_VIEWER_CHANGED_EVENT, { detail: { isOpen: next } }));
}

export function togglePdfViewerOpen() {
  setPdfViewerOpen(!isOpen);
}


